module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.heading) + " - " + _vm._s(_vm.total) + " Entries")]), _vm._v(" "), _c('button', {
    staticClass: "button is-success is-large",
    on: {
      "click": _vm.emitNew
    }
  }, [_vm._v("New Item")]), _vm._v(" "), _c('div', {
    staticClass: "table__wrapper"
  }, [_c('table', {
    staticClass: "table is-responsive is-striped is-fullwidth",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('thead', [_vm._l((_vm.headers), function(heading) {
    return _c('th', {
      key: heading
    }, [_vm._v("\n          " + _vm._s(heading) + "\n        ")])
  }), _vm._v(" "), _c('th', [_vm._v("Validate")]), _vm._v(" "), _c('th', [_vm._v("Edit")]), _vm._v(" "), _c('th', [_vm._v("Delete")])], 2), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(row) {
    return _c('tr', {
      key: row.id
    }, [_vm._l((row), function(data) {
      return _c('td', {
        key: data.id,
        staticClass: "colourdtd",
        class: {
          'unverified': row.is_verified == 0,
          'verified': row.is_verified != 0
        }
      }, [_vm._v(_vm._s(data))])
    }), _vm._v(" "), _c('td', {
      class: {
        'unverified': row.is_verified == 0,
        'verified': row.is_verified != 0
      }
    }, [_c('button', {
      staticClass: "button is-success is-small",
      on: {
        "click": function($event) {
          return _vm.validate(row)
        }
      }
    }, [(row.is_verified == 0) ? _c('div', [_vm._v("Validate")]) : _c('div', {
      staticStyle: {
        "color": "white"
      }
    }, [_vm._v("Invalidate")])])]), _vm._v(" "), _c('td', {
      class: {
        'unverified': row.is_verified == 0,
        'verified': row.is_verified != 0
      }
    }, [_c('button', {
      staticClass: "button is-warning is-small",
      on: {
        "click": function($event) {
          return _vm.edit(row)
        }
      }
    }, [_vm._v("Edit")])]), _vm._v(" "), _c('td', {
      class: {
        'unverified': row.is_verified == 0,
        'verified': row.is_verified != 0
      }
    }, [_c('button', {
      staticClass: "button is-danger is-small",
      on: {
        "click": function($event) {
          return _vm.del(row)
        }
      }
    }, [_vm._v("Delete")])])], 2)
  }), 0)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b771cdd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/EditTable/edit-table.vue
// module id = 658
// module chunks = 30